import CopyLink from '@anm/components/CopyLink';
import { getLinkTarget, getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import * as semrush from '@anm/helpers/semrush';
import { FC } from 'react';

import { BottomLinksSection, GuideLink, Title, Wrapper } from './Wrapper';

const guideLink = 'https://wave.video/help/articles/3345985';

type InviteProps = {
  link?: string;
  title?: string;
  maxGuests?: number;
  descriptionStart?: string;
  isMaxSubscription?: boolean;
};

const Invite: FC<InviteProps> = ({
  link,
  children,
  maxGuests,
  isMaxSubscription,
  descriptionStart = '',
  title = 'Invite guests to the broadcast'
}) => {
  const inviteDescription = `${descriptionStart}You can have up to ${maxGuests} participants at once`;
  const isSemrush = semrush.isSemrushIframe();

  return (
    <Wrapper>
      <Title size="small" title={title} description={inviteDescription} />
      {children}
      <CopyLink buttonText="Copy link" withField link={link || location.href.split('?skipSetup')[0]} />
      <BottomLinksSection>
        {!isSemrush && <GuideLink href={guideLink} target={getLinkTarget()}>
          Short guest guide
        </GuideLink>}
       {!isMaxSubscription && <a {...getUpgradeLinkProps()}>Need more guests?</a>}
      </BottomLinksSection>
    </Wrapper>
  );
};

export default Invite;
